var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMVentre3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 111,
    height: 178,
    viewBox: "0 0 111 178",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1162 84.3716C10.1162 84.3716 -5.18046 125.115 12.2813 147.271",
    stroke: "#909090",
    strokeMiterlimit: 10,
    strokeDasharray: "3.89 3.89"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M103.492 0.194824C111.16 24.1023 110.241 41.7049 105.496 53.491C100.751 65.277 96.0496 85.7783 95.1226 97.5174C92.4941 130.272 112.697 133.175 105.054 177.195",
    stroke: "#909090",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2199 0.194824C31.4953 11.3667 23.4469 27.7907 21.9886 39.5813C21.0046 47.5365 24.1041 53.5302 24.1041 60.0552C24.1041 64.4323 23.4973 68.8996 21.9886 72.9462C20.4798 76.9928 6.08058 117.433 16.4334 135.505C26.7862 153.578 24.1041 172.106 23.9974 177.195",
    stroke: "#909090",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMVentre3);
export default __webpack_public_path__ + "static/media/M-VENTRE_3.debbbc58f44497eb3f8e5031ba59d42d.svg";
export { ForwardRef as ReactComponent };